"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ErrorApi = require("./../../../utils/ErrorApi");

var _ErrorApi2 = _interopRequireDefault(_ErrorApi);

var _Fetch = require("./../../../utils/Fetch");

var _Fetch2 = _interopRequireDefault(_Fetch);

var _ParamsFetch = require("./../../../utils/ParamsFetch");

var _ParamsFetch2 = _interopRequireDefault(_ParamsFetch);

var _JsonFetch = require("./../../../utils/JsonFetch");

var _JsonFetch2 = _interopRequireDefault(_JsonFetch);

var _generateUrl = require("./../../../utils/generateUrl");

var _generateUrl2 = _interopRequireDefault(_generateUrl);

var _UpdateMethods = require("./UpdateMethods");

var UpdateMethods = _interopRequireWildcard(_UpdateMethods);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Service pro práci s typy dokumentu. Generated from cz.marbes.api.dokument.TypDokumentService.
 */
// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-01-07T22:18:16Z                      #

// ##############################################################

var TypDokumentApi = function () {
  function TypDokumentApi() {
    (0, _classCallCheck3.default)(this, TypDokumentApi);
  }

  (0, _createClass3.default)(TypDokumentApi, null, [{
    key: "createTypDokument",

    /**
     * Konfigurace typu dokumentu. Pokud neexistuje typ dokumentu s předaným kódem, založí ho. Pokud typ dokumentu existuje, vrací uložený záznam.
     *
     * @param kodTypDokument kód typu dokumentu
     * @param nazevDokument název typu dokumentu
     * @return založeny typ dokumentu
     */
    value: function createTypDokument(kodTypDokument, nazevDokument) {
      var uri = serverContextPath + "/api/typy/dokumentu/create";
      var headers = undefined;
      var params = { kodTypDokument: kodTypDokument, nazevDokument: nazevDokument };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, 0, headers));
    }

    /**
     * Vrací typ dokumentu s předanýcm kódem.
     *
     * @param kodTypDokument 
     * @return {@link TypDokument}
     */

  }, {
    key: "getTypDokumentByKod",
    value: function getTypDokumentByKod(kodTypDokument) {
      var uri = serverContextPath + "/api/typy/dokumentu/";
      var headers = undefined;
      var params = { kodTypDokument: kodTypDokument };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Vrací všechny typy dokumentů seřazené dle {@link TypDokument#getNazev()}.
     *
     * @return typy dokumentů
     */

  }, {
    key: "findTypyDokumentu",
    value: function findTypyDokumentu() {
      var uri = serverContextPath + "/api/typy/dokumentu/";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, 0, headers));
    }

    /**
     * Vrací kolekci šablon navázaných na typ dokumentu.
     *
     * @param kodTypDokument 
     * @return šablony navázané na typ dokumentu
     */

  }, {
    key: "getSablonyProTypDokumentu",
    value: function getSablonyProTypDokumentu(kodTypDokument) {
      var uri = serverContextPath + "/api/typy/dokumentu/sablony";
      var headers = undefined;
      var params = { kodTypDokument: kodTypDokument };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Dohledání typů dokumentu dle seznamu předaných kódů.
     *
     * @param kodTypDokuments seznam kódů typu dokumentu
     * @return seznam dohledaných typů dokumentu
     */

  }, {
    key: "getTypyDokumentu",
    value: function getTypyDokumentu(kodTypDokuments) {
      var uri = serverContextPath + "/api/typy/dokumentu/batchRequest";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, kodTypDokuments, headers));
    }
  }]);
  return TypDokumentApi;
}();

exports.default = TypDokumentApi;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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